<template>
  <q-layout view="hHh lpR fFf">
    <q-page-container>
      <q-page class="row no-wrap" style="height: 100vh; overflow: hidden;">
        <div class="col-12 col-md-3 flex column justify-center items-center q-pa-lg" style="background: white;">
          <div style="width: 100%; max-width: 400px;">
            <div class="text-center q-mb-sm">
              <img src="@/assets/douranovo.png" alt="DouraSoft Logo" style="width: 180px; height: auto;" />
            </div>

            <q-form @submit="onSubmit" class="q-gutter-md">
              <q-linear-progress indeterminate v-if="dadosLogin.isLogged" class="q-mb-md" color="blue-7" />

              <q-input
                type="email"
                v-model="email"
                label="E-mail"
                hint="Digite seu E-mail"
                lazy-rules
                :rules="[val => val && val.length > 0 || 'Endereço de E-mail inválido']"
                autofocus
              />

              <q-input
                type="password"
                v-model="senha"
                label="Senha"
                lazy-rules
                :rules="[val => val !== null && val !== '' || 'Digite sua senha']"
              />

              <div class="row items-center justify-between q-mt-xs" style="font-size: 13px;">
                <router-link to="/registro" style="text-decoration: none; color: black;">
                  Criar uma conta
                </router-link>

                <router-link to="/alterar-senha" style="text-decoration: none; color: black;">
                  Esqueci minha senha
                </router-link>
              </div>

              <div>
                <small>
                  Ao "Entrar", concordo com os
                  <a href="https://dourasoft.com.br/termos-de-uso/" target="_blank" style="color: black;">
                    Termos de uso
                  </a>
                </small>
              </div>

              <div class="text-right">
                <q-btn label="Entrar" type="submit" color="blue-7" :loading="dadosLogin.isLogged">
                  <template v-slot:loading>
                    <q-spinner color="grey-10" size="1em" />
                  </template>
                </q-btn>
              </div>
            </q-form>
          </div>
        </div>

        <div class="col-md-9 gt-sm carousel-container" :style="currentBackgroundStyle">
          <div class="overlay-gradient"></div>

          <div class="carousel-content" v-if="banners.length > 0">
            <transition name="fade" mode="out-in">
              <div :key="currentSlide" class="slide-content">
                <h2 class="slide-title" v-html="banners[currentSlide].title"></h2>
                <p class="slide-description" v-html="banners[currentSlide].description"></p>

                <q-btn
                  v-if="banners[currentSlide].button_label && banners[currentSlide].button_link"
                  :label="banners[currentSlide].button_label"
                  :href="banners[currentSlide].button_link"
                  target="_blank"
                  color="white"
                  text-color="blue-7"
                  class="q-mt-md"
                  size="md"
                />
              </div>
            </transition>

            <div class="carousel-controls" v-if="banners.length > 1">
              <button
                v-for="(banner, index) in banners"
                :key="index"
                @click="goToSlide(index)"
                :class="['control-dot', { active: currentSlide === index }]"
                :aria-label="`Ir para slide ${index + 1}`"
              ></button>
            </div>
          </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import { createMetaMixin } from "quasar";
import axios from "@/axios-unauth";

export default {
  name: "Login",
  mixins: [createMetaMixin({ title: "DSB | Login" })],
  data() {
    return {
      email: null,
      senha: null,
      banners: [],
      currentSlide: 0,
      autoplayInterval: null
    };
  },
  computed: {
    dadosLogin() {
      return this.$store.getters.login;
    },
    currentBackgroundStyle() {
      if (!this.banners.length) {
        return { background: "#f5f5f5" };
      }

      return {
        backgroundImage: `url(${this.banners[this.currentSlide].image_url})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        transition: "background-image 0.8s ease-in-out"
      };
    }
  },
  methods: {
    onSubmit() {
      if (localStorage["token" + localStorage["empresa"]]) {
        this.$router.push("/visao360");
      } else {
        this.$store.dispatch("login", {
          email: this.email,
          senha: this.senha
        });
      }
    },
    carregarBanners() {
      axios
        .get("/banners/index")
        .then(res => {
          this.banners = res.data.banners || [];
          this.currentSlide = 0;
          if (this.banners.length > 1) {
            this.startAutoplay();
          }
        });
    },
    goToSlide(index) {
      this.currentSlide = index;
      this.resetAutoplay();
    },
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.banners.length;
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    resetAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
      }
      this.startAutoplay();
    }
  },
  mounted() {
    this.carregarBanners();
  },
  beforeUnmount() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }
};
</script>

<style lang="stylus" scoped>
.q-btn
  transition all 0.3s ease

.carousel-container
  position relative
  overflow hidden

.overlay-gradient
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  background linear-gradient(to top, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.2) 50%, rgba(0, 0, 0, 0) 100%)
  z-index 1

.carousel-content
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  display flex
  flex-direction column
  justify-content flex-end
  align-items flex-end
  padding 60px
  z-index 2

.slide-content
  max-width 600px
  margin-bottom 40px
  text-align right

.slide-title
  color white
  font-size 42px
  font-weight 700
  margin 0 0 6px 0
  line-height 1.2
  text-shadow 0 2px 8px rgba(0, 0, 0, 0.2)

.slide-description
  color white
  font-size 20px
  font-weight 300
  margin 0
  opacity 0.95
  line-height 1.5
  text-shadow 0 1px 4px rgba(0, 0, 0, 0.2)

.carousel-controls
  display flex
  gap 12px

.control-dot
  width 12px
  height 12px
  border-radius 50%
  border none
  background rgba(255, 255, 255, 0.4)
  cursor pointer
  transition all 0.3s ease
  padding 0

  &:hover
    background rgba(255, 255, 255, 0.6)
    transform scale(1.1)

  &.active
    background white
    width 32px
    border-radius 6px

.fade-enter-active, .fade-leave-active
  transition opacity 0.5s ease

// Vue 3 renamed the enter start class: `-enter` is never applied any more.
.fade-enter-from, .fade-leave-to
  opacity 0
</style>